export default "__VITE_ASSET__DkS6FGiF__"